// Human labels for audit-log entries (Partner tier guide §5.8). Shared by the
// Platform audit tab, a partner's detail page and the Partner admin area so the
// same action never reads differently in two places. Unknown actions fall back
// to the raw action string.

import { TENANCY_COPY } from '../../../constants/partnerCopy';

export const AUDIT_ACTION_LABELS = {
  'partner.create': 'Partner created',
  'partner.update': 'Partner updated',
  'partner.attach_company': 'Company added to partner',
  'partner.detach_company': 'Company removed from partner',
  'company.create': 'Company created',
  'company.update': 'Company updated',
  'company.delete': 'Company deactivated',
  'entitlement.replace': 'Feature limits changed',
  'company_llm_key.upsert': 'LLM key set',
  'company_llm_key.clear': 'LLM key cleared',
  'user.create': 'User created',
  'user.activate': 'User activated',
  'user.deactivate': 'User deactivated',
  'user.reset_api_key': 'API key reset',
  'user.move_company': 'User moved',
  'user_role.assign': 'Role given',
  'user_role.remove': 'Role removed',
  'share.partner_create': 'Shared across companies',
  'share.partner_update': 'Cross-company share changed',
  'share.partner_revoke': 'Cross-company share revoked',
  'share.create': 'Shared within a company',
  'share.update': 'Share changed',
  'share.revoke': 'Share revoked',
};

export const auditActionLabel = (action) => AUDIT_ACTION_LABELS[action] || action || '—';

/** `x-admin-key` means a platform operator acted through the break-glass header. */
export const auditActorLabel = (actorLabel) =>
  actorLabel === 'x-admin-key' ? TENANCY_COPY.platformActor : actorLabel || '—';

const parseDetail = (detail) => {
  if (detail == null || detail === '') return null;
  if (typeof detail === 'object') return detail;
  try {
    return JSON.parse(detail);
  } catch {
    return null;
  }
};

const listText = (value) => (Array.isArray(value) ? value.join(', ') : String(value));

/** One readable line for the actions whose detail matters most, else null. */
export const auditDetailSummary = (action, detail) => {
  const obj = parseDetail(detail);
  if (!obj) return null;
  if (action === 'entitlement.replace') {
    const parts = [];
    if (obj.added && (!Array.isArray(obj.added) || obj.added.length)) parts.push(`Added: ${listText(obj.added)}`);
    if (obj.removed && (!Array.isArray(obj.removed) || obj.removed.length)) parts.push(`Removed: ${listText(obj.removed)}`);
    return parts.length ? parts.join(' · ') : null;
  }
  if ((action === 'user_role.assign' || action === 'user_role.remove') && obj.role_name) {
    return `Role: ${obj.role_name}`;
  }
  return null;
};
